import { HeaderConstants } from '@cxstudio/header/header-constants';

export const WidgetToolbarConstants = {
	GLOBAL_HEADER_HEIGHT: HeaderConstants.PRIMARY_HEADER_HEIGHT + HeaderConstants.SECONDARY_HEADER_HEIGHT,
	HORIZONTAL_TOOLBAR_HEIGHT: 38,
	VERTICAL_TOOLBAR_WIDTH: '2.75rem',
	FILTER_BAR_HEIGHT: 38,
	FILTER_TEMPLATE_BUTTON_HEIGHT: 42,
};